/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PreAuthFunnelBrandCountsFromJSON, PreAuthFunnelBrandCountsToJSON } from './PreAuthFunnelBrandCounts';
import { PreAuthFunnelCountsFromJSON, PreAuthFunnelCountsToJSON } from './PreAuthFunnelCounts';
/**
 * Check if a given object implements the PreAuthFunnelResponse interface.
 */
export function instanceOfPreAuthFunnelResponse(value) {
    if (!('byBrand' in value) || value['byBrand'] === undefined)
        return false;
    if (!('consentGatedEventNames' in value) || value['consentGatedEventNames'] === undefined)
        return false;
    if (!('days' in value) || value['days'] === undefined)
        return false;
    if (!('queriedAt' in value) || value['queriedAt'] === undefined)
        return false;
    if (!('total' in value) || value['total'] === undefined)
        return false;
    if (!('unavailableBrands' in value) || value['unavailableBrands'] === undefined)
        return false;
    return true;
}
export function PreAuthFunnelResponseFromJSON(json) {
    return PreAuthFunnelResponseFromJSONTyped(json, false);
}
export function PreAuthFunnelResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'byBrand': (json['byBrand'].map(PreAuthFunnelBrandCountsFromJSON)),
        'consentGatedEventNames': json['consentGatedEventNames'],
        'days': json['days'],
        'queriedAt': json['queriedAt'],
        'total': PreAuthFunnelCountsFromJSON(json['total']),
        'unavailableBrands': json['unavailableBrands'],
    };
}
export function PreAuthFunnelResponseToJSON(json) {
    return PreAuthFunnelResponseToJSONTyped(json, false);
}
export function PreAuthFunnelResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'byBrand': (value['byBrand'].map(PreAuthFunnelBrandCountsToJSON)),
        'consentGatedEventNames': value['consentGatedEventNames'],
        'days': value['days'],
        'queriedAt': value['queriedAt'],
        'total': PreAuthFunnelCountsToJSON(value['total']),
        'unavailableBrands': value['unavailableBrands'],
    };
}
